/*
 * action types
 */
export const NAV_BAR = 'NAV_BAR'

/*
 * action creators
 */

export default function navBar(title, subtitle, category) {
  return {
    payload: {
      category,
      subtitle,
      title,
    },
    type: NAV_BAR,
  }
}
